import request from '@/utils/request'


// 查询病情反馈列表
export function listIllness(query) {
  return request({
    url: '/biz/illness-feedback/list',
    method: 'get',
    params: query
  })
}

// 查询病情反馈分页
export function pageIllness(query) {
  return request({
    url: '/biz/illness-feedback/page',
    method: 'get',
    params: query
  })
}

// 查询病情反馈详细
export function getIllness(data) {
  return request({
    url: '/biz/illness-feedback/detail',
    method: 'get',
    params: data
  })
}

// 新增病情反馈
export function addIllness(data) {
  return request({
    url: '/biz/illness-feedback/add',
    method: 'post',
    data: data
  })
}

// 修改病情反馈
export function updateIllness(data) {
  return request({
    url: '/biz/illness-feedback/edit',
    method: 'post',
    data: data
  })
}

// 删除病情反馈
export function delIllness(data) {
  return request({
    url: '/biz/illness-feedback/delete',
    method: 'post',
    data: data
  })
}
